import React from "react";
import {useLocation, useMatches} from "react-router-dom";
import './breadcrumbs-by-routes.scss';
import LinkWrapper from "../LinkWrapper/LinkWrapper";
import {useTypedSelector} from "../../redux/Hooks/storeSelectors";
import {selectEntities} from "../../redux/selectors/selectors";


const BreadcrumbsByRoutes = () => {
    const {pathname: curPathname} = useLocation();
    const entities = useTypedSelector(selectEntities);

    const matches = useMatches()
        .filter((match) => Boolean(match.handle?.['crumb'] as any))
        .map(({handle, ...restMatch}: any) => ({
            ...restMatch,
            crumb: handle.crumb(restMatch.data)
        }));

    return (
        <div className="breadcrumbs">
            <ul aria-label="breadcrumbs">
                {matches.map(({pathname, crumb: {label, id, name, entityName, pathnamePostFix, testId}}, index) => {
                    const {name: nameInEntity} = entities[entityName] ?? {};
                    const breadcrumb = `${label ? `${label}: ` : ''}${nameInEntity ?? name ?? id}`;

                    return (
                        <li key={index}>
                            <LinkWrapper
                                className="breadcrumbs__item"
                                to={`${pathname}${pathnamePostFix ? `${pathnamePostFix}` : ''}`}
                                hasLink={pathname !== curPathname}
                                {...(testId ? {'data-testid': testId} : {})}
                            >
                                {breadcrumb}
                            </LinkWrapper>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default BreadcrumbsByRoutes;